var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-history-ct" },
    [
      _c("Filters", {
        on: {
          submit: function($event) {
            return _vm.submit($event)
          }
        }
      }),
      _vm._v(" "),
      _c("history-table", {
        staticClass: "tb",
        attrs: {
          isShowPage: true,
          list: _vm.data,
          currentPage: _vm.currentPage,
          toPage: _vm.update,
          totalPage: _vm.totalPage
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }